<template>
  <header class="header">
    <div class="header__text-box">
      <h1 class="heading-primary">
        <span class="heading-primary--main">On</span>
        <span class="heading-primary--sub">Veterinary</span>
        <span class="heading-primary--sub2">AI</span>
      </h1>
      <a
        href="#section-projects"
        class="btn btn--white btn--animated"
      >Discover the projects</a>
    </div>
  </header>
</template>
<script>
export default {
  name: 'Header'
}
</script>
